import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/store";
import { format } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";

const translationPath = "page.authorizations.";

export const ReadData = memo(() => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const user = useAppSelector((state) => state.user);

  return (
    <Stack
      sx={(t) => ({
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: t.palette.background.default,
        padding: "10px 0",
        display: "flex",
        justifyContent: "start",
        zIndex: 1000,
      })}
    >
      <Stack
        sx={{
          ml: matches ? 0 : 15,
          minWidth: 300,
          maxWidth: 800,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" color="textSecondary">
          {`${t(translationPath + "date_time_read")}: ${format(
            new Date(),
            "Pp",
            {
              locale: language === "pt-BR" ? ptBR : enUS,
            }
          )}`}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {`${t(translationPath + "user")}: ${user.userName} - ${
            user.fullName
          }`}
        </Typography>
      </Stack>
    </Stack>
  );
});
